import axios from 'axios';

async function getSTSCredentials() {
    const response = await axios.get('/api/oss-sts-token/get');
    const info = response.data.data || response.data;
    const credentials = {
        accessKeyId: info.accessKeyId || info.AccessKeyId,
        accessKeySecret: info.accessKeySecret || info.AccessKeySecret,
        stsToken: info.stsToken || info.securityToken || info.SecurityToken,
    };
    if (!credentials.accessKeyId || !credentials.accessKeySecret || !credentials.stsToken) {
        throw new Error('Invalid OSS STS credentials');
    }
    return credentials;
}

export async function createOSSClient(ossConfig) {
    const credentials = await getSTSCredentials();
    return new window.OSS({
        ...ossConfig,
        authorizationV4: true,
        ...credentials,
        refreshSTSToken: getSTSCredentials,
        refreshSTSTokenInterval: 1800000,
    });
}
